<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.4616 4.87868C12.1852 4.59909 11.7346 4.59557 11.4538 4.87082L6.18609 10.0771L3.89617 7.70646C3.62305 7.4218 3.17089 7.41246 2.88627 7.68558C2.60161 7.95869 2.59226 8.41085 2.86538 8.69548C2.86662 8.69675 2.86783 8.69802 2.86906 8.69928L5.66114 11.5928C5.79476 11.7291 5.97739 11.8063 6.16827 11.807H6.17613C6.3634 11.8065 6.54296 11.7323 6.67612 11.6006L12.4552 5.88651C12.7344 5.60962 12.7373 5.15913 12.4616 4.87868V4.87868Z"
      fill="black"
      fill-opacity="0.25"
    />
  </svg>
</template>
